<template lang="html">
  <section>
    <h2>Enter the token to confirm your account</h2><br>
    <input v-model="confirmationToken" type="text"><br>
    <b-button type="is-primary"
      tag="input"
      native-type="submit"
      value="Submit"
      @click.prevent="confirm"
      @keyup.enter="confirm" />
  </section>
</template>

<script>
export default {
  data () {
    return {
      confirmationToken: null
    }
  },
  methods: {
    confirm () {
      this.$store.dispatch('confirmations/create', this.confirmationToken)
        .then(username => {
          this.$buefy.dialog.alert({
            title: 'Account confirmed',
            message: 'Congratulations , your account had been confirmed !',
            onConfirm: () => this.$router.push(`/users/${username}`)
          })
        })
        .catch(error => {
          console.log('Errors')
          console.log(error.response)
        })
    }
  },
  mounted () {
    if (this.$route.query.token) {
      this.confirmationToken = this.$route.query.token
      this.confirm()
    } else {
      console.log('There is no token')
    }
  }
}
</script>

<style lang="css" scoped>
</style>
